export default from './MobileMessages';



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/index.js